export interface PurchaseOrderReportLineProcessing {
  processProductKey: string;
  processProductDescription: string;
}
